module.exports = __webpack_public_path__ + "media/6.a858a0c9.aac";